import React, {useEffect} from "react";
import {ToastOptions, useIonToast} from "@ionic/react";

// long enough to read a message, closable earlier; toasts do not block the rest of the UI
export const errorToastOptions = (message: string): ToastOptions => ({
    message,
    color: "danger",
    duration: 10000,
    buttons: [{text: "Close", role: "cancel"}],
});

export const ErrorToast: React.FC<{error: string | null, errorId: number}> = params => {
    const [present] = useIonToast();

    // the error is cleared by the next successful request (e.g. the refresh right after a failed change),
    // so the toast is not dismissed then and stays for its full duration.
    // Keyed by errorId, not by the message: failing the same way twice in a row must show the toast again
    useEffect(() => {
        if (params.error != null) {
            present(errorToastOptions("Error: " + params.error));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.errorId, present]);

    return <></>
};
